/**
 * Renders a simple bullet list from markdown-style "- " lines, or a
 * single paragraph if the content isn't list-formatted. Service
 * full_content is admin-edited free text (see admin/content routes),
 * so this stays forgiving about format rather than requiring strict
 * structured input from the content editor.
 */
function parseListOrParagraph(content: string): string[] {
  const lines = content
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);

  const bulletLines = lines.filter((l) => l.startsWith('-') || l.startsWith('•'));
  if (bulletLines.length > 0) {
    return bulletLines.map((l) => l.replace(/^[-•]\s*/, ''));
  }
  return [content];
}

export function BenefitsList({ content }: { content: string }) {
  const items = parseListOrParagraph(content);
  return (
    <ul className="space-y-2">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-2 text-ink/75">
          <span className="mt-1 text-ledger-green">✓</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export function EligibilityList({ content }: { content: string }) {
  const items = parseListOrParagraph(content);
  return (
    <ul className="space-y-2">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-2 text-ink/75">
          <span className="mt-1 text-seal-blue">•</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
